import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";
import NProgress from "nprogress";

import BlankLayout from "@/layouts/blank-layout/Blanklayout";
import FullLayout from "@/layouts/full-layout/FullLayout";
import TeacherLayout from "@/layouts/teacher-layout/TeacherLayout";
import PartnerLayout from "@/layouts/partner-layout/PartnerLayout";
import BaseLayout from "@/layouts/base-layout/Layout";

Vue.use(Router);

// Route meta for authentication and transitions
const teacherAuthMeta = {
  auth: { roles: ["Teacher"], forbiddenRedirect: { name: "TeacherLogin" } },
  transitionName: "slide",
};
const baseAuthMeta = {
  auth: {
    roles: ["Planner", "Administrator", "Sales", "Partner"],
    forbiddenRedirect: { name: "Login" },
  },
};

const InternalAuthMeta = {
  auth: {
    roles: ["Planner", "Administrator", "Sales"],
    forbiddenRedirect: { name: "Login" },
  },
};

const routes = [
  {
    path: "/full",
    component: FullLayout,
    children: [
      {
        path: "datum-selecteren/:token",
        name: "DateSelect",
        component: () => import("@/views/dateselect/DateSelect"),
        props: true,
        meta: { transitionName: "slide" },
      },
      {
        path: "datum-kiezen/:token",
        name: "ChooseDate",
        component: () => import("@/views/datechoose/ChooseDate"),
        props: true,
        meta: { transitionName: "slide" },
      },
    ],
  },
  {
    path: "/partner",
    component: PartnerLayout,
    meta: baseAuthMeta,
    children: [
      {
        path: "agenda",
        name: "partnerPortalView",
        component: () => import("@/views/partnerportal/calendar/CalendarView"),
        meta: baseAuthMeta,
        props: true,
      },
    ],
  },
  {
    path: "/teacher",
    component: TeacherLayout,
    meta: teacherAuthMeta,
    children: [
      {
        path: "agenda",
        name: "TeacherPortalView",
        component: () =>
          import("@/views/teacherportal/TeacherPortalCalendarView"),
        meta: teacherAuthMeta,
        props: true,
      },
      {
        path: "aanvragen",
        name: "TeacherPortalRequestsView",
        component: () =>
          import("@/views/teacherportal/TeacherPortalRequestsView"),
        meta: teacherAuthMeta,
        props: true,
      },
      {
        path: "handleiding",
        name: "TeacherPortalManualView",
        component: () =>
          import("@/views/teacherportal/TeacherPortalManualView"),
        redirect: "/teacher/handleiding/algemeen",
        children: [
          {
            path: "agenda",
            name: "TeacherManualCalendarView",
            component: () =>
              import("@/views/teacherportal/manual/TeacherManualCalendarView"),
            meta: teacherAuthMeta,
          },
          {
            path: "algemeen",
            name: "TeacherManualDefaultView",
            component: () =>
              import("@/views/teacherportal/manual/TeacherManualDefaultView"),
            meta: teacherAuthMeta,
          },
          {
            path: "aanvragen",
            name: "TeacherManualRequestsView",
            component: () =>
              import("@/views/teacherportal/manual/TeacherManualRequestsView"),
            meta: teacherAuthMeta,
          },
          {
            path: "synchronisatie",
            name: "TeacherManualSyncView",
            component: () =>
              import("@/views/teacherportal/manual/TeacherManualSyncView"),
            meta: teacherAuthMeta,
          },
        ],
      },
      {
        path: "invullen/:token/:type",
        name: "TeacherPortalFillView",
        component: () => import("@/views/teacherportal/TeacherPortalFillView"),
        meta: teacherAuthMeta,
        props: true,
      },
    ],
  },
  {
    path: "/",
    component: BaseLayout,
    meta: InternalAuthMeta,
    redirect: "/home",
    children: [
      {
        path: "course",
        name: "course",
        component: () => import("@/views/course/ViewCourse"),
        meta: { transitionName: "slide" },
      },
      {
        path: "deleted",
        name: "deleted",
        component: () => import("@/views/homepage/OptionsDeleted"),
        meta: { transitionName: "slide" },
      },
      {
        path: "/teacher/:id",
        name: "TeacherView",
        props: true,
        component: () => import("@/views/teacher/TeacherView"),
        meta: { transitionName: "slide" },
      },
      {
        path: "/multiple-teacher",
        name: "MultipleTeacherView",
        props: true,
        component: () => import("@/views/teacher/MultipleTeacherView"),
        meta: { transitionName: "slide" },
      },
      {
        path: "/devtools/",
        name: "DevelopmentTools",
        meta: {
          auth: {
            roles: ["Administrator"],
            forbiddenRedirect: { name: "home" },
          },
        },
        props: true,
        component: () => import("@/views/development/DevelopmentTools"),
      },
      {
        path: "/instellingen/",
        name: "Settings",
        meta: {
          auth: {
            roles: ["Administrator"],
            forbiddenRedirect: { name: "home" },
          },
        },
        props: true,
        component: () => import("@/views/settings/UserSettings"),
      },
      {
        path: "/option/:id",
        name: "OptionView",
        redirect: "/option/:id/overzicht",
        props: true,
        component: () => import("@/views/courseoption/CourseOptionView"),
        meta: { transitionName: "slide" },
        children: [
          {
            name: "OptionDates",
            path: "datums",
            component: () =>
              import("@/views/courseoption/courseoptiontabs/Dates"),
          },
          {
            name: "OptionOverview",
            path: "overzicht",
            component: () =>
              import("@/views/courseoption/courseoptiontabs/Overview"),
          },
          {
            name: "OptionTimeline",
            path: "tijdlijn",
            component: () =>
              import("@/views/courseoption/courseoptiontabs/Timeline"),
          },
          {
            name: "OptionCompanies",
            path: "bedrijven",
            component: () =>
              import("@/views/courseoption/courseoptiontabs/Companies"),
          },
          {
            name: "OptionEmails",
            path: "emails",
            component: () =>
              import("@/views/courseoption/courseoptiontabs/Emails"),
          },
          {
            name: "OptionSpecifications",
            path: "specificaties",
            component: () =>
              import("@/views/courseoption/courseoptiontabs/Specifications"),
          },
        ],
      },
      {
        path: "/course/:id",
        name: "viewCourse",
        props: true,
        component: () => import("@/views/course/ViewCourse"),
        meta: { transitionName: "slide" },
      },
      {
        path: "/multiple-courses",
        name: "MultipleCoursesView",
        props: true,
        component: () => import("@/views/course/MultipleCourseView"),
        meta: { transitionName: "slide" },
      },
      {
        path: "/home",
        component: () => import("@/Homepage"),
        redirect: "/home/opties",
        children: [
          {
            name: "Options",
            path: "opties",
            component: () => import("@/views/homepage/Options"),
          },
          {
            name: "Courses",
            path: "cursussen",
            component: () => import("@/views/homepage/Courses"),
            props: true,
          },
          {
            name: "Teachers",
            path: "docenten",
            redirect: "docenten/overzicht",
            component: () => import("@/views/homepage/Teachers"),
            children: [
              {
                name: "DefaultTeachers",
                path: "overzicht",
                component: () =>
                  import("@/views/teacher/overview/DefaultTeachersView"),
              },
              {
                name: "DefaultOptions",
                path: "docentopties",
                component: () =>
                  import("@/views/teacher/overview/OptionTeachersView"),
              },
              {
                name: "DefaultTeacherSearch",
                path: "docentzoeken",
                component: () =>
                  import("@/views/teacher/overview/TeacherSearchView"),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "/authentication",
    component: BlankLayout,
    children: [
      {
        name: "Login",
        path: "login",
        component: () => import("@/views/authentication/planner/Login"),
        meta: {
          auth: false,
          forbiddenRedirect: { name: "TeacherLogout" },
        },
      },
      {
        name: "ForgotPassword",
        path: "forgotpassword",
        component: () =>
          import("@/views/authentication/password/ForgotPassword"),
        meta: {
          auth: false,
        },
      },
      {
        name: "ResetPassword",
        path: "resetpassword",
        component: () =>
          import("@/views/authentication/password/ResetPassword"),
        meta: {
          auth: false,
        },
        props: (route) => ({ token: route.query.token || null }),
      },
      {
        name: "TeacherLogin",
        path: "teacherlogin/:id",
        props: true,
        component: () => import("@/views/authentication/teacher/TeacherLogin"),
        meta: {
          auth: false,
          forbiddenRedirect: { name: "TeacherLogout" },
        },
      },
      {
        name: "TeacherLogout",
        path: "uitgelogd",
        props: true,
        component: () => import("@/views/authentication/teacher/TeacherLogout"),
        meta: {
          auth: false,
        },
      },
    ],
  },
];

const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) =>
    goTo(savedPosition ? savedPosition.y : to.hash || 0),
  routes,
});

// Utility function for auth guard
function authGuard(to, from, next) {
  const user = Vue.auth.user();
  if (user) {
    const roles = user.roles;
    if (roles.includes("Teacher") && to.name === "Options")
      return router.push({ name: "TeacherPortalView" });

    if (roles.includes("Partner") && to.name === "Options")
      return router.push({ name: "partnerPortalView" });
  }
  next();
}

router.beforeEach((to, from, next) => {
  authGuard(to, from, next);
  NProgress.start(800);
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
